<template>
  <div>
    <div class="ethics" id="ethics" v-if="ethics && ethics.length > 0">
      <h2 class="theme-background" v-if="ethics[0].title && ethics[0].title.length > 0">
        <component :is="'jo' + item1.name" v-for="item1 in ethics[0].title" v-bind:key="item1.index" v-bind:data="item1.data"></component>
      </h2>
      <h2 class="theme-background" v-else>{{ARTICLE.defaultlang=='zh'?'伦理道德声明':'Ethical Statements'}}</h2>
      <div v-for="(ethic,index) in ethics ">
        <p v-for="item in ethic.data">
          <component :is="'jo' + item1.name" v-for="item1 in item.data" v-bind:key="item1.index" v-bind:data="item1.data"></component>
        </p>
      </div>
    </div>
    <div class="ethics" v-for="(sec, index) in backSec" :key="'sec' + index">
      <h2 class="theme-background" v-if="sec.title && sec.title.length > 0">
        <component :is="'jo' + item1.name" v-for="item1 in sec.title" v-bind:key="item1.index" v-bind:data="item1.data"></component>
      </h2>
      <p v-for="item in sec.data">
        <component :is="'jo' + item1.name" v-for="item1 in item.data" v-bind:key="item1.index" v-bind:data="item1.data"></component>
      </p>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        ethics: this.ARTICLE.ethics,
        backSec: this.ARTICLE.backSec
      }
    },
    created() {
    }
  }
</script>



// WEBPACK FOOTER //
// src/commonComponents/ethics.vue